// extracted by mini-css-extract-plugin
module.exports = {"header":"header__2vICj","description":"description__o0I_H","innerContainer":"innerContainer__3o76n","content":"content__1pAl2"};